import { InfoWarningIcon } from "themes/Icon";
import CheckboxComp from "themes/elements/Checkbox";
import ChipSelect from "themes/elements/ChipSelect";
import ColorChipSelect from "themes/elements/ColorChipSelect";
import DatePickerComp from "themes/elements/DatePicker";
import FileUpload from "themes/elements/FileUpload";
import InputComp from "themes/elements/Input";
import TimePickerComp from "themes/elements/TimePicker";
import TooltipComp from "themes/elements/Tooltip";
import dateUtils from "utils/dateUtils";
import style from "../../../CreateNotification/create_noti.module.scss";

function LeftSection(props) {
  const {
    setCategoryId,
    categoryId,
    setLoadCategory,
    categoryData,
    isEdit,
    isDuplicate,
    selectedNews,
    imageCaption,
    setImageCaption,
    setAuthorImage,
    source,
    recipients,
    recipientsData,
    setRecipientsFlag,
    setRecipientsData,
    expire,
    setExpire,
    setExpiry,
    disableExpiry,
    expiry,
    myNewsArticle,
    setScheduleDate,
    setScheduleTime,
    schedule,
    setSchedule,
    disableScheduleDate,
    scheduleDate,
    author,
    setAuthor,
    setSource,
    setNewsImage,
    newsImage,
    handleImageUpdate,
    authorImage,
    approval,
  } = props;
  return (
    <div className={`flex flex-column gap-5 ${style["left-section"]}`}>
      {/* Select News Category */}
      <div className="flex flex-column">
        <label className="input-label mb-2">Category</label>
        <ColorChipSelect
          setCategoryId={setCategoryId}
          categoryId={categoryId}
          setLoadCategory={setLoadCategory}
          categoryData={categoryData}
          defaultValue={(isEdit || isDuplicate) && selectedNews?.category}
        />
      </div>
      {/* Image caption */}
      <div>
        <InputComp
          value={imageCaption}
          label="Image caption"
          placeholder="Provide image caption"
          onChange={(e) => setImageCaption(e.target.value)}
          maxLength={100}
          showCount={true}
        />
      </div>
      {/* Upload Image/Thumbnail */}
      <div className="flex flex-column gap-2">
        <label className="input-label">Image/Thumbnail</label>
        <FileUpload
          deleteModalOpen={isEdit && selectedNews?.news_image_filepath}
          previewImage={newsImage}
          type="news"
          handleImageUpdate={handleImageUpdate}
          defaultFileList={
            isEdit
              ? selectedNews?.banner_img && [
                  {
                    uid: "-1",
                    name: "Thumbnail image",
                    url: selectedNews?.banner_img,
                  },
                ]
              : null
          }
          setPreviewImage={setNewsImage}
          title="Upload news image"
        />
      </div>
      {/* Author Name */}
      <div>
        <InputComp
          value={author}
          onChange={(e) => setAuthor(e.target.value)}
          label="Author"
          placeholder="Provide author name"
          maxLength={40}
          showCount={true}
        />
      </div>
      {/* Upload Author Image */}
      <div className="flex flex-column gap-2">
        <label className="input-label">Author image</label>
        <FileUpload
          deleteModalOpen={isEdit && selectedNews?.author_image_path}
          previewImage={authorImage}
          type="author"
          handleImageUpdate={handleImageUpdate}
          defaultFileList={
            isEdit
              ? selectedNews?.author_image && [
                  {
                    uid: "-1",
                    name: "Thumbnail image",
                    url: selectedNews?.author_image,
                  },
                ]
              : null
          }
          setPreviewImage={setAuthorImage}
          title="Upload author image"
        />
      </div>
      {/* Source */}
      <div className="flex flex-column gap-2">
        <label className="input-label">
          <span className="flex align-center gap-1">
            Source
            <TooltipComp placement="top" title="News source details">
              <span>
                <InfoWarningIcon />
              </span>
            </TooltipComp>
          </span>
        </label>
        <div>
          <InputComp
            value={source}
            onChange={(e) => {
              setSource(e.target.value);
            }}
            maxLength={20}
            placeholder="Provide source details"
            showCount={true}
          />
        </div>
      </div>
      {/* Recipients */}
      <div>
        <ChipSelect
          isDuplicate={isDuplicate}
          isEdit={isEdit}
          options={recipients}
          defaultValues={recipientsData}
          setRecipientsFlag={setRecipientsFlag}
          onChange={(value) => {
            setRecipientsData(value);
          }}
        />
      </div>
      {/* set expiry date */}
      <div className="flex flex-column gap-2">
        <CheckboxComp
          isChecked={expire}
          setChecked={setExpire}
          label="Set an expiry date"
        />
        {expire && (
          <div className="flex align-center gap-4">
            <DatePickerComp
              onChange={(dateString) => {
                setExpiry(dateString);
              }}
              disabledDate={disableExpiry}
              value={expiry}
            />
          </div>
        )}
      </div>
      {approval && (
        <div className="flex flex-column gap-2">
          <CheckboxComp
            onChange={() => {
              setScheduleDate(null);
              setScheduleTime(null);
            }}
            isChecked={schedule}
            setChecked={setSchedule}
            label="Schedule Submission for Approval"
          />
          {schedule && (
            <div className="flex align-center gap-4">
              <DatePickerComp
                onChange={(dateString) => {
                  setScheduleDate(dateString);
                }}
                disabledDate={disableScheduleDate}
                value={scheduleDate}
              />
              <TimePickerComp
                date={scheduleDate}
                defaultValue={dateUtils.getDateTime(
                  selectedNews?.scheduled_date,
                  "time"
                )}
                onChange={(time, time12HourFormat, time24HourFormat) =>
                  setScheduleTime(time24HourFormat)
                }
                placeholder="Select time"
                disabled={!scheduleDate}
              />
            </div>
          )}
        </div>
      )}
      {/* schedule publishing */}
      {myNewsArticle && (
        <div className="flex flex-column gap-2">
          <CheckboxComp
            onChange={() => {
              setScheduleDate(null);
              setScheduleTime(null);
            }}
            isChecked={schedule}
            setChecked={setSchedule}
            label="Schedule publishing"
          />
          {schedule && (
            <div className="flex align-center gap-4">
              <DatePickerComp
                onChange={(dateString) => {
                  setScheduleDate(dateString);
                }}
                disabledDate={disableScheduleDate}
                value={scheduleDate}
              />
              <TimePickerComp
                date={scheduleDate}
                defaultValue={dateUtils.getDateTime(
                  selectedNews?.scheduled_date,
                  "time"
                )}
                onChange={(time, time12HourFormat, time24HourFormat) =>
                  setScheduleTime(time24HourFormat)
                }
                placeholder="Select time"
                disabled={!scheduleDate}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default LeftSection;
